// extracted by mini-css-extract-plugin
export default {"cross":"ModalTitle_cross__Zm1AK"};